
import {ServerProdApi, ServerDistApi,ServerProdApidl} from '../../../src/group-cloud/network/ServerBizApi';
import {Mod_Roles} from "./Roles";

export class Mod_Role_Warehouse {

    public static async loadRoleInfo(roleId) {

        let url = 'auth_center/yooz/role/role_auth_list';
        let formData =  {
            role_id: roleId,
        };
        let response = await ServerProdApi.send(url, formData);
        return response.result;

    }


    public static async saveRole(data) {

        let formData;

        formData    = {
            group_id: data.user_type,
            rolename: data.role_name,
        };

        let url = 'auth_center/yooz/role/add';
        if (data.role_id > 0) {
            url = 'auth_center/yooz/role/update';
            formData.role_id = data.role_id;
        }

        let response = await ServerProdApi.send(url, formData);
        return response.result;

    }

    public static async getRolesMap(groupId = 0) {

        let url = 'rbacRole_list';
        let formData;
        formData =  {};
        if (groupId > 0) {
            formData.groupId = groupId;
        }
        let response = await ServerProdApi.send(url, formData);

        let map = {};
        let idx, _key;


         //修改返回
        for(idx = 0; idx < response.result.length; idx++) {
            _key = response.result[idx].id;
            map[_key] = response.result[idx].rolename;

        }

        return map;

    }

    public static async syncWhMap(userId, whIds) {

        let url = '/warehouse/save';
        let formData =  {
            userId: userId,
            wes: whIds,
        };
        let response = await ServerProdApidl.send(url, formData);

        let menuIds = [];

        if (response.result && response.result.warehouse_ids) {
            menuIds     = response.result.warehouse_ids;
        }

        return menuIds;

    }

    public static async getWhMap(userId) {

        let url = 'auth_center/yooz/role/get_warehouse_map';
        let formData =  {
            user_id: userId,
        };
        let response = await ServerProdApi.send(url, formData);

        let menuIds = [];

        if (response.result && response.result.warehouse_ids) {
            menuIds     = response.result.warehouse_ids;
        }

        return menuIds;

    }

    public static async getMemberList(data) {

        let url = 'warehouse/list';
        let formData = data;
        let response = await ServerProdApidl.send(url, formData);
        return response.result;

    }

    public static getMemberWhString(record) {

        let ret = '';

        let roles = [], idx;
        if (record && record.warehouse && record.warehouse.length) {

            for (idx = 0; idx < record.warehouse.length; idx++) {
                roles.push(record.warehouse[idx].name);
            }

            if (roles.length) {
                ret = roles.join(',');
            }
        }

        return ret;

    }

    public static async getWarehouseList_raw() {

        let url = '/wms/ws/list';
        let formData =  {"type":"DIST"};
        let response = await ServerDistApi.send(url, formData);
        return response.result;
    }


    public static async getWarehouseList_wms() {
        let url = '/wms/ws/list';
        let formData =  {"type":"DIST"};
        let response = await ServerDistApi.send(url, formData);
        let idx, tree = [];
        if (response.result && response.result.length) {
            tree    = Mod_Roles.buildMenuTreeWms(response.result, 1);
        }
        return tree;
    }

    public static async getWarehouseList_skip_role_check_raw() {
        let url = '/wms/ws/all';
        let formData =  {"type":"DIST"};
        let response = await ServerDistApi.send(url, formData);
        return response.result;
    }

    public static async getWarehouseList_wms_skip_role_check() {
        let url = '/wms/ws/all';
        let formData =  {"type":"DIST"};
        let response = await ServerDistApi.send(url, formData);
        let idx, tree = [];
        if (response.result && response.result.length) {
            tree    = Mod_Roles.buildMenuTreeWms(response.result, 1);
        }
        return tree;
    }

    public static async getWarehouseList() {

        let url = 'auth_center/yooz/role/warehouse_tree';
        let formData =  {};
        let response = await ServerProdApi.send(url, formData);

        let idx, tree = [];

        if (response.result && response.result.length) {
            tree    = Mod_Roles.buildMenuTree(response.result, 'name', 1);
        }

        return tree;

    }


    public static async bindRoleMenus(roleId, MenuIds) {
        let url = 'auth_center/yooz/role/auth_menu';
        let formData =  {
            role_id: roleId,
            menu_id: MenuIds,
        };
        let ret = 0;
        let response = await ServerProdApi.send(url, formData);
        if (response.succ) {
            ret = 1;
        }
        return ret;
    }


}


